var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',[_c('div',{staticClass:"project_types"},[(_vm.item.project_types.length)?_vm._l((_vm.item.project_types),function(project_type,index){return _c('div',{key:index},[_vm._v(" "+_vm._s(project_type.name)+" ")])}):_c('span',[_vm._v(_vm._s(_vm.localStorage.translations.pages.common.text['net-dannyh']))])],2)]),_c('td',[_vm._v(" "+_vm._s(_vm.item.name)+" ")]),_c('td',[_c('div',{staticClass:"buttons"},[(
          _vm.$userCheckAccess({
            abilities: 'edit_work_type',
          })
        )?_c('WorkTypeCategoryModal',{attrs:{"create":false,"id":_vm.item.id}}):_vm._e(),(
          _vm.$userCheckAccess({
            abilities: 'edit_work_type',
          })
        )?_c('DeleteModal',{attrs:{"item":_vm.item,"text":_vm.localStorage.translations.pages['setting-work_type_category']['dialog-delete'][
            'udalit-kategoriyu-rabot'
          ] +
          ' ' +
          _vm.item.name,"textSecond":_vm.localStorage.translations.pages['setting-work_type_category']['dialog-delete'][
            'dlya-udaleniya-kategorii-rabot'
          ] +
          ' ' +
          _vm.item.name +
          _vm.localStorage.translations.pages['setting-work_type_category']['dialog-delete'][
            'neobhodimo-udalit-svyazi'
          ],"textCheckbox":_vm.localStorage.translations.pages['common']['checkbox']['delete_all_links']}}):_vm._e()],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }